import {  useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Modal from "./modal/Modal";
import { states } from "../data/states";
import Loader from "./loader/Loader";
import {useAuthContext} from "../context/AuthContext"
import axiosInstance from "../config/axios";
import toast from "react-hot-toast";

const CustomerInfo = () => {
  const {user, setUser} = useAuthContext()
  const [showPopup_, setShowPopup_] = useState(false)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const {t} = useTranslation()


    const [userData, setUserData] = useState({
        address:user.address ?? "",
        city:user.city ?? "",
        state:user.state ?? "",
        zip:user.zip ?? "",
        race:user.race ?? "",
        gender:user.gender ?? "",
    })

    const [otherInput, setOtherInput] = useState("")
    const [otherChecked, setOtherChecked] = useState(false)

    useEffect(()=>{
      if(user.address || user.city || user.zip || user.race || user.gender){
        setShowPopup_(!showPopup_)
      }},[user])

    const handleInputs = (e)=>{
        const name = e.target.name
        const value = e.target.value
        if(name === "genderMale" || name === "genderFemale" || name === "genderOther"){
            if(name === "genderOther"){
              setOtherChecked(true)
                setUserData(prev=>({...prev, gender : otherInput}))
            }else{
              setOtherChecked(false)
                setUserData(prev=>({...prev, gender:value}))
            }
        }else{
            setUserData(prev=>({...prev , [name] : value}))
        }
    }

    useEffect(()=>{
       if(otherInput){
        setUserData(prev=>({...prev, gender : otherInput}))
       }
    },[otherInput])

    const handleSubmit = async(e)=>{
      e.preventDefault();
      if(!userData.address || !userData.city || !userData.state || !userData.zip || !userData.gender || !userData.race ){
        toast.error(t("Please fill all the details"))
        return
      }
      try {
        setLoading(true)
        const response = await axiosInstance.put(`user/${user.id}`, userData)
        if(response.status === 200){
           setUser(response.data.user)
           if(response.data.user.minor){
            navigate("/gaurdian-info")
           }else{
             navigate("/dashboard")
           }
        }
      } catch (error) {
        toast.error(t("Something went wrong"))
      }finally{
        setLoading(false)
      }
    }


    const handleYes = () => {
      setShowPopup_(false)
    }
    
    const handleNo = ()=>{
      if(user.minor){
        navigate("/gaurdian-info")
      }else{
        navigate("/dashboard")
      }
    }

  return (

    <>
    {showPopup_ && (
        <Modal>
          <p className="text-3xl font-bold mb-4 text-black">
            {t("Do you want to update your Info?")}
          </p>
          <div className="flex  gap-5 items-center">
          <button
            className="yellowButton text-black py-2 px-8 rounded-3xl font-bold mt-4"
            onClick={handleYes}
          >
            {t("Yes")}
          </button>
          <button
            className="yellowButton text-black py-2 px-8 rounded-3xl font-bold mt-4"
            onClick={handleNo}
          >
            {t("No")}
          </button>
           
          </div>
        </Modal>
      )}
    <div className="w-full h-full flex flex-col items-center overflow-auto p-4 text-white gap-4">
        <label className="font-bold text-xl  md:text-4xl text-white  uppercase text-center">{t("Additional info")}</label>
      <form className="flex flex-col max-w-2xl w-full justify-between h-full overflow-auto" onSubmit={handleSubmit}>
        <div className="flex flex-col gap-4 w-full">
          <div className="flex justify-between md:items-center md:flex-row flex-col">
            <label className="flex gap-3 md:w-20 w-full">{t("Address")} :</label>
            <input
              name="address"
              placeholder="Address"
              type="text"
              className="p-2 rounded-lg text-black md:flex-1"
              value={userData.address}
              onChange={handleInputs}
              ></input>
          </div>

          <div className="flex justify-between md:items-center md:flex-row flex-col">
            <label className="flex gap-3 md:w-20 w-full">{t("City")} :</label>
            <input
              name="city"
              placeholder="City"
              type="text"
              className="p-2 rounded-lg text-black md:flex-1"
              value={userData.city}
              onChange={handleInputs}
              ></input>
          </div>

          <div className="flex justify-between md:items-center md:flex-row flex-col">
            <label className="flex gap-3 md:w-20 w-full">{t("State")} :</label>
            <select
              name="state"
              placeholder="State"
              type="text"
              className="p-2 rounded-lg text-black md:flex-1"
              value={userData.state}
              onChange={handleInputs}
              >
                <option value="">Select State</option>
                {
                  states.map(state=><option key={state}>{state}</option>)
                }
              </select>
          </div>

          <div className="flex justify-between md:items-center md:flex-row flex-col">
            <label className="flex gap-3 md:w-20 w-full">{t("Zip")} :</label>
            <input
              name="zip"
              placeholder="Zip"
              type="number"
              className="p-2 rounded-lg text-black md:flex-1"
              value={userData.zip}
              onChange={handleInputs}
              ></input>
          </div>

          <div className="flex items-center md:flex-row flex-col">
            <label className="flex  md:w-20 w-full">{t("Gender")} :</label>
            <div className="flex flex-col md:flex-1 w-full">
              <div className="flex gap-2">
            <label className="flex gap-2 items-center ml-1">
            <input name="genderMale" type="radio" value="male" checked={userData.gender === "male"} onChange={handleInputs}></input>
                {t("Male")}
            </label>
            <label className="flex gap-2 items-center">
            <input name="genderFemale" type="radio" value="female" checked={userData.gender === "female"} onChange={handleInputs}></input>
                {t("Female")}
            </label>
            <label className="flex gap-2 items-center">
                <input name="genderOther" type="radio" checked={otherChecked} onChange={handleInputs}></input>
                {t("other")} 
            </label>
              </div>
            {otherChecked && <input type="text" className="p-2 rounded-lg text-black" value={otherInput} onChange={(e)=>setOtherInput(e.target.value)} ></input>}
            </div>
          </div>

          <div className="flex justify-between md:items-center md:flex-row flex-col">
            <label className="flex gap-3 md:w-20 w-full">{t("Race")} :</label>
            <input
              name="race"
              placeholder="Race"
              type="text"
              maxLength={30}
              className="p-2 rounded-lg text-black md:flex-1"
              value={userData.race}
              onChange={handleInputs}
              ></input>
          </div>
        </div>

        <button disabled={loading} className="yellowButton px-4 py-2 text-black font-bold self-center rounded-3xl mt-3">
          {loading ? <Loader /> : t("Submit")}
        </button>
      </form>
    </div>
              </>
  );
};

export default CustomerInfo;
